import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the EditroutePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;

@Component({
  selector: 'page-editroute',
  templateUrl: 'editroute.html',
})
export class EditroutePage {
  @ViewChild('mapFull') mapElement: ElementRef;
  Map: any
  RouteTitle = ''
  RouteId = ''
  Pois = []
  Areas = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController) {
    this.RouteTitle = this.navParams.get('name')
    this.RouteId = this.navParams.get('rid')
    this.Pois = this.navParams.get('pois')
    //debugger

    for (var i = 0; i < this.Pois.length; i++) {
      if (this.Pois[i].geom + '' != 'null') {
        this.Pois[i].geom = this.Pois[i].geom.replace('POINT', '')
        this.Pois[i].geom = this.Pois[i].geom.replace('POLYGON', '')
        this.Pois[i].geom = this.Pois[i].geom.replace(/\(/g, '')
        this.Pois[i].geom = this.Pois[i].geom.replace(/\)/g, '')
        var poz = this.Pois[i].geom.indexOf(',')
        if (poz > -1) {
          this.Pois[i].geom = this.Pois[i].geom.substring(0, poz)
        }
        var tmp = this.Pois[i].geom.split(' ')
        if (this.Pois[i].gtype == 'ST_Point') {
          this.Pois[i].lat = parseFloat(tmp[1])
          this.Pois[i].lon = parseFloat(tmp[0])
        } else {
          // this.Pois[i].lat = parseFloat(tmp[0])
          // this.Pois[i].lon = parseFloat(tmp[1])
          this.Pois[i].lat = parseFloat(this.Pois[i].clat)
          this.Pois[i].lon = parseFloat(this.Pois[i].clong)
        }
        // console.log()
        //"POINT(21.3393799999974 41.0346319999997)"
        // "POLYGON((41.979390857244 21.476210247934,41.979689943832 21.476440917918,41.979470613805 21.476811062776,41.979179501876 21.47652674861,41.979390857244 21.476210247934))"

        this.Pois[i].marker = null
      }
    }
    // console.log(this.Pois)
  }

  ionViewDidLoad() {
    //debugger
    // console.log('ionViewDidLoad EditroutePage');
    this.initMap()
  }

  initMap() {
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('edit route') }, function () {
    })
    this.Map.setCenter({ lat: 41.998802, lng: 21.427379 })
    this.drawMarkers()
  }

  reorderItems(from, to) {
    let element = this.Pois[from];
    this.Pois.splice(from, 1);
    this.Pois.splice(to, 0, element);
    this.drawMarkers()
  }
  deleteTocka(idx) {
    this.Pois.splice(idx, 1)
    this.drawMarkers()
  }

  drawMarkers() {
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < this.Pois.length; i++) {
      if (this.Pois[i].marker != null) {
        this.Pois[i].marker.setMap(null)
        this.Pois[i].marker = null
      }
      var img = 'assets/imgs/newpin-blue.png'
      if (i == 0) { img = 'assets/imgs/newpin-green.png' }
      if (i == this.Pois.length - 1) { img = 'assets/imgs/newpin-red.png' }
      var markerIcon = {
        url: img,
        scaledSize: new google.maps.Size(38, 43),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(13, 43),
        labelOrigin: new google.maps.Point(13, 13)
      };

      /*done*/this.Pois[i].marker = new google.maps.Marker({
        position: { lat: parseFloat(this.Pois[i].lat), lng: parseFloat(this.Pois[i].lon) },
        map: this.Map,
        icon: markerIcon, //'assets/imgs/pin-blue.png',
        label: {
          text: (parseInt(i + '') + 1) + '',
          color: "#000",
          fontSize: "14px",
          fontWeight: "bold",
        },
      });

      if (this.Pois[i].gtype != 'ST_Point') {
        var _that = this
        this.gn._Post('/api/gn/getonezone', { zid: this.gn.crypt(this.Pois[i].ppid) }, function (_data) {
          // console.log(_data[0])
          for (var i = 0; i < _data.length; i++) {
            // console.log()
            var _pois = _data[i].pois.split(",")
            var pp = []
            for (var j = 0; j < _pois.length; j++) {
              var tmp = _pois[j].split(' ')
              pp.push({ lon: parseFloat(tmp[1]), lat: parseFloat(tmp[0]) })
            }
            // console.log(_data[i].color, pp, _data[i].name)
            // var idx = _that.drawPoly(_data[i].color, pp, _data[i].name, _id)
            // _that.tempZones[_id + ''] = { data: _data, index: idx }
            // _that.CenterMap2thisPois(pp)
            _that.drawPoly(_data[i].color, pp, _data[i].name, _that.Pois[i].id)
          }
        })
      }

      bounds.extend({ lat: parseFloat(this.Pois[i].lat), lng: parseFloat(this.Pois[i].lon) });
    }
    this.Map.fitBounds(bounds);
  }


  drawPoly(_color, _pois, _title, _id) {
    // console.log('drawPoly', _color, _pois, _title)
    var _pp = []
    for (var i = 0; i < _pois.length; i++) {
      _pp.push({ lat: _pois[i].lat, lng: _pois[i].lon })
    }
    var _poly = new google.maps.Polygon({
      paths: _pp,
      strokeColor: _color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: _color,
      fillOpacity: 0.35,
      id: _id
    });
    // var hasArea = false;
    // for (var j = 0; j < this.Areas.length; j++) {
    //   if (this.Areas[j].id == _id)
    //     hasArea = true;
    // }
    // if (!hasArea) {
    //   alert(888)
    _poly.setMap(this.Map)
    //   this.Areas.push(_poly)
    // }
    // console.log(this.historyMap)

    //alert(this.Areas.length + ' * ' + this.tochkiPoseta.length)
    // _poly.AreaName = _title
    // _poly.AreaId = _zoneid
    // _poly.AreaColor = _color
  }

  savePredef() {
    if (this.RouteTitle == '') {
      const alert = this.alertCtrl.create({
        subTitle: this.dic.l["MustEnterRouteName"] + ' !',
        buttons: [this.dic.l['ok']]
      });
      alert.present();
      return
    }
    var pp = []
    var poiids = [];
    var poinames = [];
    //console.log(this.Pois)
    for (var i = 0; i < this.Pois.length; i++) {
      this.Pois[i].rbr = i + 1
      pp.push(this.Pois[i].id + '|' + this.Pois[i].rbr)
      poiids.push(this.Pois[i].ppid)
      poinames.push(this.Pois[i].opis)
    }

    var _that = this
    this.gn._Post('/api/gn/savepredefroute', { id: this.gn.crypt(this.RouteId), name: this.gn.crypt(this.RouteTitle), pois: this.gn.crypt(pp.join('@')), poiids: this.gn.crypt(poiids.toString()), poinames: this.gn.crypt(poinames.toString()), cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      // console.log(this.Pois)
      var cb = _that.navParams.get('cb')
      cb()
      _that.navCtrl.pop()
    })

  }

  delPredef() {
    var _that = this
    this.gn._Post('/api/gn/delpredefroute', { id: this.gn.crypt(this.RouteId) }, function (_data) {
      var cb = _that.navParams.get('cb')
      cb()
      _that.navCtrl.pop()
    })
  }
}




// WEBPACK FOOTER //
// ./src/pages/routing/editroute/editroute.ts